var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visionboard-sidebar"},[_c('el-button',{staticClass:"btn-block d-block mx-auto w-100",on:{"click":_vm.toggleVisionboardChallengeSidebar}},[_vm._v("Close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }